export default __webpack_public_path__ + "static/media/loading.6281c6f4.gif";